//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import angular from 'angular';
import React from 'react';

import makeAngularReactController from '@react-bridge/angular-react-widget';
import AutoApprovalModal from '@streams/components/AutoApprovalModal';

angular.module('curalate').component('autoApprovalModal', {
  controller: makeAngularReactController(<AutoApprovalModal />),
});
